/**
 * Склонение числительных по падежам
 * @param {Number} num - Числительное
 * @param {Array} arr - массив из 3 слов, например ['год', 'года', 'лет']
*/
export default function declOfNum(num, arr) {
    let n = num;
    n = Math.abs(n) % 100;
    const n1 = n % 10;
    if (n > 10 && n < 20) { return arr[2]; }
    if (n1 > 1 && n1 < 5) { return arr[1]; }
    if (n1 === 1) { return arr[0]; }
    return arr[2];
}
